<template>
  <span :class="[ns.b()]">
    <el-dropdown trigger="click">
      <div>
        <el-tooltip
          effect="light"
          placement="top"
          :disabled="!showTip"
          :content="t('epx.editor.imageTip')"
        >
          <Icon :icon="Image" size="20" color="#000000" />
        </el-tooltip>
      </div>

      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item>
            <online-image @change="handleOnlineImage" />
          </el-dropdown-item>
          <el-dropdown-item>
            <upload-image
              :trigger-name="t('epx.editor.uploadPicture')"
              @change="handleUploadImage"
            />
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import {
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElTooltip,
  useLocale,
  useNamespace,
} from 'element-plus'
import * as IconsVue from '@element-plus/components/icons-vue/index'
import Icon from '../icon.vue'
import { useToolBarContext } from '../../hooks'
import UploadImage from '../upload/index.vue'
import OnlineImage from './online.vue'
import type { UploadFile } from 'element-plus'
import type { ISetImageOptions, IToolbarImage } from '../../types'

const ns = useNamespace('editor-image')
const { t } = useLocale()
const { Image } = IconsVue

defineOptions({
  name: 'EditorImage',
  inheritAttrs: false,
})

const toolBarContext = useToolBarContext()
const showTip = computed(() => toolBarContext.value.configure.showTip)

const getEditor = () => toolBarContext.value.editor
const getConfigure = () =>
  toolBarContext.value.configure?.image ?? { onChange: () => {} }

const setImage = (options: ISetImageOptions) => {
  getEditor().chain().focus().setImage(options).run()
}

const handleOnlineImage = (options: ISetImageOptions) => {
  setImage(options)
}

const handleUploadImage = (uploadFile: UploadFile) => {
  const imageConfig: IToolbarImage = getConfigure()
  imageConfig.onChange(uploadFile, (options: ISetImageOptions) => {
    setImage(options)
  })
}
</script>
